import { render } from "./DatePicker.vue?vue&type=template&id=18c56f00&ts=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__